import {Box, BoxProps} from "@mui/material";

export const HorizontalBox = ({ sx, ...other }: BoxProps) => {
	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "row",
				...sx
			}}
			{...other}
		/>
	);
};